export default {
  "mission-statement":
    "<span class='opacity-80'>Our mission: </span>orchestrate the rise of solar energy <span class='opacity-80'>for all of us.</span>",
  intro: {
    title: "Actor of France's energy independence",
    subtitle: "Advancing the energy transition, together",
    description:
      "From the beginning, our mission has been to orchestrate the rise of solar energy on a large scale for all of us. We are realizing France's solar project by helping each individual solar project to be realized with confidence, even for individuals. We are proud to be able to help. Because if every citizen achieves energy independence at home, then France will have also achieved it.",
  },
  story: {
    title: "Our journey",
    "paragraph-1":
      "Our technology aims to reduce the digital divide that is widening in our country.",
    "paragraph-2":
      "Our daily IT tool will soon help thousands of local photovoltaic artisans to grow their activities. Know that they form a fragile economic fabric that is now essential to the vitality of rural communities. Photovoltaic installations already generate essential income for the survival of agricultural, wine-growing and beekeeping operations.",
    "paragraph-3":
      "The photovoltaic sector is the source of a real job pool within rural territories, source of high-level technical work therefore well-paid. Solar energy thus contributes to the development of a local economy, at the heart of a regenerative energy transition. It is our impoverished territories that are regaining prosperity.",
    "paragraph-4":
      "France's energy independence is possible thanks to clean technologies; and we are at the forefront because we are at the cutting edge.",
    "paragraph-5":
      "We launched into solar as soon as we understood how difficult it is for our parents to become self-sufficient in clean energy, despite the tremendous progress of photovoltaic technologies.",
    "paragraph-6":
      "Based in Provence, our young innovative company is made up of solar energy specialists and computer scientists. To date, we have never needed to raise money or spend a single euro on advertising. On the contrary, our method is customer satisfaction and word of mouth.",
    "paragraph-7":
      "Our experiences abroad, and self-taught training in electrical engineering, allow us today to give ourselves the means to achieve our ambitions.",
    "paragraph-8":
      "Our ambition? Solar energy everywhere for all of us... and thus respond to the climate justice ideals of the Paris Agreement.",
  },
  stats: {
    title: "We are solar project orchestrators",
    description:
      "Our community platform connects all solar project holders with all photovoltaic and storage professionals; together with all energy transition stakeholders - engineering firms, suppliers, financiers, municipalities, public services.",
    "flagship-projects": "Online construction sites",
    "flagship-projects-stat": "100+ MW",
    "installers-on-our-platform": "Photovoltaic artisans",
    "solar-projects-enabled": "Solar projects propelled",
    "followers-stat": "25,000+",
    followers: "People follow us",
  },
  missionStats: {
    title: "Actor of France's energy independence",
    description: "From the beginning, our mission has been to orchestrate the rise of solar energy on a large scale for all of us. We are realizing France's solar project by helping each individual solar project to be realized with confidence, even for individuals. We are proud to be able to help. Because if every citizen achieves energy independence at home, then France will have also achieved it.",
    signature: "Maarten and Georges",
    stats: {
      solarProjects: {
        value: "+122 MW",
        label: "of solar projects"
      },
      companies: {
        value: "+1,000",
        label: "Photovoltaic companies"
      },
      projectsEnabled: {
        value: "+8,000",
        label: "solar projects propelled"
      },
      followers: {
        value: "+25,000",
        label: "People follow us"
      }
    }
  },
  team: {
    header: {
      badge: "Our team",
      title: "United by passion",
      description: "Driven by creativity and dedication, our team brings together diverse skills and perspectives to turn ideas into impactful solutions.",
      button: "Découvrir opportunités à pourvoir"
    },
    title: "The team behind the technology",
    description:
      "We are passionate about what we do and committed to achieving the best results for our clients.",
    people: {
      "person-1": {
        name: "Georges",
        role: "Relations Manager & Co-founder",
        bio: "Georges Séraphim-André Nevsky helps thousands of our fellow citizens discover their solar potential. He helps photovoltaic artisans benefit from new cutting-edge technologies.",
      },
      "person-2": {
        name: "Yann",
        role: "Operations Manager & Co-founder",
        bio: "Yann Vermeil Schremmer develops new internal operating modes, then coordinates various external stakeholders to combine entrepreneurship and environment.",
      },
      "person-3": {
        name: "Maarten",
        role: "Technology Manager & Co-founder",
        bio: "Maarten Elgar develops the technology that helps households switch to solar energy by allowing them to obtain competitive quotes, then complete the rest of the journey online.",
      },
      "person-4": {
        name: "Kelly",
        role: "Developer",
        bio: "Kelly Muscat creates the website visuals. She aims to make projetsolaire shine, which is close to her heart for its noble mission: making solar more accessible for both professionals and individuals!",
      },
      "person-5": {
        name: "Alice",
        role: "Community Coordinator",
        bio: "Alice Lucà contributes to the development of our brand, optimizes our online presence and participates in the growth of communities related to photovoltaics, for solar energy accessible to all.",
      },
      "person-6": {
        name: "Wakidou",
        role: "Frontend Developer",
        bio: "Wakidou Abdallah is a frontend developer. He contributes to the development of the platform by creating ergonomic and efficient interfaces. His goal is to facilitate and accelerate the transition to solar through the community portal.",
      },
      "person-7": {
        name: "Louise",
        role: "Growth Operations Coordinator",
        bio: "Louise Remy is a growth operations coordinator. She is the link between installers and our development and operations teams. Her goal is to improve our tool to the maximum for the full satisfaction of our customers.",
      },
      "person-8": {
        name: "Amal",
        role: "Sales Coordinator",
        bio: "Amal plays an essential role in monitoring sales processes, ensuring good organization of commercial actions and maintaining an effective link with customers to support team objectives.",
      },
      "person-9": {
        name: "Ludovic",
        role: "Product Specialist",
        bio: "Ludovic, Product Specialist, accompanies you with expertise to offer you the best solutions. He ensures that each product perfectly meets your needs, thus guaranteeing a smooth and efficient experience. His priority is to help you achieve your goals by offering personalized and quality service.",
      },
    },
  },
  office: {
    title: "Come visit us!",
    subtitle: "Located in the Old Port of Marseille, we chose a headquarters in an old art workshop, next to the Memorial of La Marseillaise, to contribute to the regeneration of the neighborhood.",
    location: {
      region: "Provence",
      address: "11 rue Thubaneau, 13001 Marseille, France"
    },
    maps: "Show in Maps"
  },
  career: {
    title: "Our projetsolaire is growing. Grow with us.",
    description:
      "Based in Provence, we are looking for talents to flourish and prosper. Want to have an impact on the climate by helping our fellow citizens make the solar revolution? Welcome!",
    openings: {
      title: "Currently open positions",
      "fullstack-engineer": "Fullstack Developer",
    },
  },
} 